export default __webpack_public_path__ + "static/media/cf3.ca6e532f.jpg";